import { render, staticRenderFns } from "./CalendarioLaboral.vue?vue&type=template&id=5c9ebc01&scoped=true&"
import script from "./CalendarioLaboral.vue?vue&type=script&lang=ts&"
export * from "./CalendarioLaboral.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarioLaboral.vue?vue&type=style&index=0&id=5c9ebc01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9ebc01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
